import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'Montserrat', Arial, sans-serif",
  },
  palette: {
    background: {
      default: "#3E3F29",
      paper: "#3E3F29",
    },
    text: {
      primary: "#ffffff",
      secondary: "#ffffff",
    },
    custom: {
      border: "#481E14",
    },
  },
});

export default theme;